/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
function e(e,{profiles:r}){const t=e.title;if(null!=t)return t;switch(e.type){case"ground":return r.ground;case"input":return r.input;case"query":return r.query;case"view":return r.view;default:return""}}export{e as getTranslatedLineTitle};
